import React from "react";
import { Button } from "../ui/button";
import { useN2Offer } from "../../lib/useN2Offer";
import { formatCOP } from "../../lib/apiClient";

/**
 * Modal para solicitar contacto comercial N2.
 */
export function ContactRequestModal({ show, onClose, caseDoc, acting, onConfirm }) {
  const n2Offer = useN2Offer();
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      onClick={onClose}
      data-testid="n2-contact-modal-overlay"
    >
      <div
        className="bg-white max-w-md w-full p-6 rounded-sm shadow-xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="n2-contact-modal"
      >
        <h3 className="font-serif text-xl text-gray-900 mb-3">
          Solicitar contacto Kit Documental
        </h3>
        <p className="text-sm text-gray-700 mb-4">
          Un asesor te contactará en <strong>1-2 días hábiles</strong> para presentarte el paquete
          documental Kit Documental ({formatCOP(n2Offer.price_reviewed_cop)}). Confirmamos tu correo:
        </p>
        <p className="text-sm font-mono bg-gray-100 px-3 py-2 mb-4 rounded-sm">
          {caseDoc?.user_email || "tu correo registrado"}
        </p>
        <div className="flex gap-2 justify-end">
          <Button
            variant="outline"
            onClick={onClose}
            disabled={acting}
            className="rounded-sm"
            data-testid="n2-contact-cancel"
          >
            Cancelar
          </Button>
          <Button
            onClick={onConfirm}
            disabled={acting}
            className="rounded-sm"
            data-testid="n2-contact-confirm"
          >
            {acting ? "Enviando…" : "Confirmar solicitud"}
          </Button>
        </div>
      </div>
    </div>
  );
}
